import React, { useEffect} from 'react'
import {Route, Routes} from "react-router-dom"
// import {CallbackPage} from "./pages/callback-page"
import {AuthenticationGuard} from "./utils/AuthenticationGuard"
import {TradeCalculator} from './pages/TradeCalculator'
// import {NewTradeCalculator} from './pages/NewTradeCalculator'
import {Troubleshoot} from './pages/Troubleshoot'
// import history from "./utils/history"
import {BestAvailable} from './pages/BestAvailable'
import {useTCData, useBAData} from "./context"

const App = () => {
  const {setTCData, setTCDataError, setTCDataLoading} = useTCData();
  const {setBAData, setBADataError, setBADataLoading} = useBAData()

  const formatTCData = ({ data }) => {
    return data.map(item => {
      const formattedData = item.data.map(i => {
        const [name, year1, year2, year3, pTV, total, average] = i;
        return { name, year1, year2, year3, pTV, total, average };
      });
      return { setName: item.setName, data: formattedData };
    });
  };

  const formatBAData = ({data}) => {
    return data.map(item => {
      const formattedData = item.data.map(i => {
        const [ranking, tier, playerId, player, position, team, age, previous, movement] = i
        return {ranking, tier, playerId, player, position, team, age, previous, movement}
      })
      return { setName: item.setName, data: formattedData }
    })
  }

  useEffect(() => {
    setTCDataLoading(true)
    const fetchTCData = async () => {
      try {
        const response = await fetch("https://frozen-headland-24495.herokuapp.com/trade-calculator", { mode: 'cors' });
        // const response = await fetch("http://localhost:3001/trade-calculator", { mode: 'cors' })
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }
        const data = await response.json();
        const formattedData = formatTCData({ data });
        setTCData(formattedData);
        setTCDataLoading(false)
      } catch (error) {
        console.error('Error fetching data:', error.message);
        setTCDataLoading(false)
        setTCDataError(true)
        // Handle error gracefully (e.g., display error message)
      }
    };

    fetchTCData();
  }, [setTCData, setTCDataLoading, setTCDataError]);

  useEffect(() => {
    setBADataLoading(true)
    const fetchBaData = async () => {
      try {
        const response = await fetch("https://frozen-headland-24495.herokuapp.com/best-available", { mode: 'cors' });
        // const response = await fetch("http://localhost:3001/best-available", { mode: 'cors' })
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }
        const data = await response.json();
        const formattedData = formatBAData({ data });
        // console.log({formattedData})
        setBAData(formattedData)
        setBADataLoading(false)
      } catch (error) {
        console.error('Error fetching data:', error.message);
        setBADataLoading(false)
        setBADataError(true)
        // Handle error gracefully (e.g., display error message)
      }
    }

    fetchBaData()
  }, [setBAData, setBADataError, setBADataLoading])

  return(
    <div className="App">
      <header className="App-header">
    {/* <LogoutButton /> */}
      {/* <NavBar /> */}
      </header>
    <Routes> 
        {/* <Route exact path="/" element={<AuthenticationGuard component={TradeCalculator} />} />
        {/* <Route exact path="/trade-calculator" element={<NewTradeCalculator/>} /> */}
        {/* <Route exact path="/trade-calculator"  element={<AuthenticationGuard component={Troubleshoot} />} />
        <Route exact path="/best-available" element={<AuthenticationGuard component={BestAvailable} />} />  */}
        <Route exact path="/" element={<TradeCalculator/>} />
        <Route exact path="/best-available" element={<BestAvailable/>} />
    </Routes>
    </div>
     
  )
}

export default App
